<template>
  <card-container
    id="customer-reset-password"
    class="customer-reset-password"
    :loading-message="`Sending Reset Password Email to ${customerEmail}...`"
    :is-loading="isLoading"
    :disabled="!isEmailValid || isLoading"
    @submit="submitForm"
    @reset="resetForm"
  >
    <template #title>
      Send Password Reset Email to Customer
    </template>

    <template #content>
      <div class="row">
        <label class="col-sm-3 control-label pt-10"> Customer Email* </label>
        <div class="col-sm-6">
          <email-input
            v-model="customerEmail"
            required
            @update-validation="updateEmailValidation"
          />
        </div>
      </div>
    </template>

    <template #submit-button>
      Send Email
    </template>
  </card-container>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { sendPost } from '@/Utils/api';

const { customerInfo } = useCustomer();

const { showSuccessPopupDialog, showErrorPopupDialog } = useSwalDialog();

const customerEmail = ref('');
const isLoading = ref(false);
const isEmailValid = ref(true);

const updateEmailValidation = (value: boolean) => {
  isEmailValid.value = value;
};

const submitForm = async () => {
  isLoading.value = true;
  try {
    await sendPost('forgot', {
      email: customerEmail.value,
    });

    showSuccessPopupDialog({
      text: `The reset password email has been sent to ${customerEmail.value} successfully.`,
    });
  } catch (error) {
    const errorText = util.getErrorResponse(error, false);
    showErrorPopupDialog({
      text: errorText,
    });
  }
  isLoading.value = false;
};

const resetForm = () => {
  customerEmail.value = customerInfo.value?.email || '';
};

watch(customerInfo, resetForm, {
  immediate: true,
});
</script>
